import { ImageList, ImageListItem, ImageListItemBar, IconButton } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { Photo } from '@features/visits/api';

type VisitDetailPhotoGridProps = {
  photos: Photo[];
  onPhotoClick: (photo: Photo) => void;
  onDeleteClick: (photo: Photo) => void;
};

const VisitDetailPhotoGrid = ({
  photos,
  onPhotoClick,
  onDeleteClick,
}: VisitDetailPhotoGridProps) => {
  return (
    <ImageList cols={3} gap={8}>
      {photos.map(photo => (
        <ImageListItem key={photo.id} sx={{ cursor: 'pointer' }}>
          <img
            src={photo.url}
            alt={photo.description || 'Hairstyle photo'}
            loading="lazy"
            style={{ height: 150, objectFit: 'cover', borderRadius: '8px' }}
            onClick={() => onPhotoClick(photo)}
          />
          <ImageListItemBar
            sx={{ borderRadius: '0 0 8px 8px' }}
            title={photo.description || ''}
            subtitle={new Date(photo.uploadedAt).toLocaleDateString()}
            actionIcon={
              <IconButton
                sx={{ color: 'white' }}
                onClick={e => {
                  e.stopPropagation();
                  onDeleteClick(photo);
                }}
              >
                <DeleteIcon />
              </IconButton>
            }
          />
        </ImageListItem>
      ))}
    </ImageList>
  );
};

export default VisitDetailPhotoGrid;
